<template>
	<div class="data19">
		<div class="data19TilBox">
			<div class="data19Til">{{list.data.menuTitle}}</div>
			<div class="data19Tab">
				<div class="data19TabFor" :id="'item'+index" v-for="(item,index) in list.data.content" :key="index" @click="goTab(index)" :style="{
					color:tabXz==index?'#000000':'#999999',
					
				}">
					{{item.type_name}}
					<!-- :style="{
						left:tabLeft,
					}" -->
					
				</div>
				<div class="data19TabXian" :style="{
						left:tableftTwo+'px',
						width:tabWidth
					}">
				
				</div>
			</div>
		</div>
		<div>
			<div class="swiper-hexin" :class="`swiper-hexin${list.index}`" >
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item,index) in list.data.content" :key="index">
						<div class="swiper-hexinTwo" :class="`swiper-hexinTwo${list.index}`">
							<div class="swiper-wrapper">
								<div class="swiper-slide swiper-slideTwo" v-for="(itema,indexa) in item.child"
									:key="indexa">
									<div class="swiper-slideTwo-img">
										<img :src="itema.cover" />
									</div>
									<div class="swiper-slideTwo-name">
										{{itema.title}}
									</div>
									<div class="swiper-slideTwo-cen">
										<div v-for="(itemc,indexc) in itema.desc" :key="indexc">{{itemc.text}}</div>
									</div>
								</div>
							</div>
							<template v-if="headerShow">
								<div class="swiper-hexin-prev"  :style="{
									display:prev,
									left:`calc(${bj}px + 30px)`
								}">
									<img src="@/assets/product/page6/zjt.png" />
								</div>
								<div class="swiper-hexin-next"  :style="{
									display:next,
									right:`calc(${bj}px + 30px)`
								}">
									<img src="@/assets/product/page6/yjt.png" />
								</div>
							</template>
							<template v-else>
								<div class="swiper-hexin-prev"  :style="{
									display:prev,
									left:`30px`
								}">
									<img src="@/assets/product/page6/zjt.png" />
								</div>
								<div class="swiper-hexin-next"  :style="{
									display:next,
									right:`30px`
								}">
									<img src="@/assets/product/page6/yjt.png" />
								</div>
							</template>
							
						</div>
					</div>
				</div>

			</div>

		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props:{
			list:{
				typeof:Object,
				default:{}
			}
		},
		data() {
			return {
				tabList: [{
						name: '结肠镜适应性推进技术',
						list: [{
								img: require("@/assets/content/hexinBanner.png"),
								name: '同步传导',
								cen: '- 结肠镜插入部的惯性设计将手柄处操作者的推拉力和旋转力传递到结肠镜的先端部- 能够帮助医生更好地进镜到盲肠'
							},
							{
								img: require("@/assets/content/hexinBanner.png"),
								name: '软硬可调',
								cen: '- 结肠镜插入管具有多级软硬度调整功能，通过旋转调节环可改变插入部的软硬度- 可满足结肠不同部位的进镜需求'
							},
							{
								img: require("@/assets/content/hexinBanner.png"),
								name: '随动弯曲',
								cen: '-顺应结肠不同部位的转向，在脾曲肝曲等部位自适应扭转镜身向空腔行进-'
							},
							{
								img: require("@/assets/content/hexinBanner.png"),
								name: '软硬可调',
								cen: '- 结肠镜插入管具有多级软硬度调整功能，通过旋转调节环可改变插入部的软硬度- 可满足结肠不同部位的进镜需求'
							},
							{
								img: require("@/assets/content/hexinBanner.png"),
								name: '随动弯曲',
								cen: '-顺应结肠不同部位的转向，在脾曲肝曲等部位自适应扭转镜身向空腔行进-'
							},
						]
					},
					{
						name: '高效诊疗',
						list: [{
								img: require("@/assets/content/hexinBanner.png"),
								name: '同步传导qq',
								cen: '- 结肠镜插入部的惯性设计将手柄处操作者的推拉力和旋转力传递到结肠镜的先端部- 能够帮助医生更好地进镜到盲肠'
							},
							{
								img: require("@/assets/content/hexinBanner.png"),
								name: '软硬可调qq',
								cen: '- 结肠镜插入管具有多级软硬度调整功能，通过旋转调节环可改变插入部的软硬度- 可满足结肠不同部位的进镜需求'
							},
							{
								img: require("@/assets/content/hexinBanner.png"),
								name: '随动弯曲qq',
								cen: '-顺应结肠不同部位的转向，在脾曲肝曲等部位自适应扭转镜身向空腔行进-'
							},
							{
								img: require("@/assets/content/hexinBanner.png"),
								name: '软硬可调',
								cen: '- 结肠镜插入管具有多级软硬度调整功能，通过旋转调节环可改变插入部的软硬度- 可满足结肠不同部位的进镜需求'
							},
							{
								img: require("@/assets/content/hexinBanner.png"),
								name: '随动弯曲',
								cen: '-顺应结肠不同部位的转向，在脾曲肝曲等部位自适应扭转镜身向空腔行进-'
							},
						]
					},
					{
						name: '升级手柄',
						list: [{
								img: require("@/assets/content/hexinBanner.png"),
								name: '同步传导bb',
								cen: '- 结肠镜插入部的惯性设计将手柄处操作者的推拉力和旋转力传递到结肠镜的先端部- 能够帮助医生更好地进镜到盲肠'
							},
							{
								img: require("@/assets/content/hexinBanner.png"),
								name: '软硬可调bb',
								cen: '- 结肠镜插入管具有多级软硬度调整功能，通过旋转调节环可改变插入部的软硬度- 可满足结肠不同部位的进镜需求'
							},
							{
								img: require("@/assets/content/hexinBanner.png"),
								name: '随动弯曲bb',
								cen: '-顺应结肠不同部位的转向，在脾曲肝曲等部位自适应扭转镜身向空腔行进-'
							},
							{
								img: require("@/assets/content/hexinBanner.png"),
								name: '软硬可调',
								cen: '- 结肠镜插入管具有多级软硬度调整功能，通过旋转调节环可改变插入部的软硬度- 可满足结肠不同部位的进镜需求'
							},
							{
								img: require("@/assets/content/hexinBanner.png"),
								name: '随动弯曲',
								cen: '-顺应结肠不同部位的转向，在脾曲肝曲等部位自适应扭转镜身向空腔行进-'
							},
						]
					},
				],
				tabXz: 0,
				mySwiperTwo: '',
				mySwiper: "",
				innerSwipers: [],
				sliact: 0,
				prev:'none',
				next:'block',
				bj:'',
				tableftTwo:0,
				tabWidth:''
			}
		},
		watch:{
			bj(){
				let t=this;
				let name='.swiper-hexin'+this.list.index;
				this.mySwiper = new this.$swiper(name, {
					// 方向
					direction: 'horizontal',
					observer: true, //修改swiper自己或子元素时，自动初始化swiper，主要是这两行
					observeParents: true,
					// 自动播放
					autoplay: false,
					allowTouchMove: false,
				});
				t.innerSwipers = [];
				// let a = document.getElementsByClassName('swiper-hexinTwo');
				let nameTwo='.swiper-hexinTwo'+this.list.index;
				let a = document.querySelectorAll(nameTwo);
				a.forEach(function(container) {
					if(t.headerShow){
						var innerSwiper = new t.$swiper(container, {
							// 内部Swiper的选项
							direction: 'horizontal',
							widch: 580,
							slidesPerView: 'auto', // 每屏显示3个滑块
							spaceBetween: 40,
							slidesOffsetBefore: t.bj,
							slidesOffsetAfter: t.bj,
							// 自动播放
							autoplay: false,
							observer: true, //修改swiper自己或子元素时，自动初始化swiper，主要是这两行
							observeParents: true,
							navigation: {
								prevEl: ".swiper-hexin-prev",
								nextEl: ".swiper-hexin-next",
							},
							on: {
								slideChangeTransitionEnd: function() {
									if(t.list.data.content[t.tabXz].child.length>2){
										t.prev = 'none';
										t.next = 'block';
									}else{
										t.prev = 'none';
										t.next= 'none';
										return
									}
									if (this.activeIndex === 0) {
										t.prev = 'none';
									} else {
										t.prev = 'block';
									}
									if (this.activeIndex === this.slides.length - 1) {
										t.next= 'none';
									} else {
										t.next = 'block';
									}
									if (this.activeIndex === this.slides.length - 2) {
										t.next = 'none';
									} else {
										t.next = 'block';
									}
									// if (t.sliact == this.activeIndex && t.sliact == this.slides.length - 2) {
									// 	t.next = 'none';
									// } else {
									// 	t.sliact = this.activeIndex;
									// }
								},
							},
						});
					}else{
						var innerSwiper = new t.$swiper(container, {
							// 内部Swiper的选项
							direction: 'horizontal',
							slidesPerView: 'auto', // 每屏显示3个滑块
							slidesOffsetBefore: t.bj,
							slidesOffsetAfter: t.bj,
							// 自动播放
							autoplay: false,
							observer: true, //修改swiper自己或子元素时，自动初始化swiper，主要是这两行
							observeParents: true,
							allowTouchMove: t.list.data.content[t.tabXz].child.length > 1 ? true : false,
							navigation: {
								prevEl: ".swiper-hexin-prev",
								nextEl: ".swiper-hexin-next",
							},
							on: {
								slideChangeTransitionEnd: function() {
									if(t.list.data.content[t.tabXz].child.length>2){
										t.prev = 'none';
										t.next = 'block';
									}else{
										t.prev = 'none';
										t.next= 'none';
										return
									}
									if (this.activeIndex === 0) {
										t.prev = 'none';
									} else {
										t.prev = 'block';
									}
									if (this.activeIndex === this.slides.length - 1) {
										t.next= 'none';
									} else {
										t.next = 'block';
									}
									// if (this.activeIndex === this.slides.length - 2) {
									// 	t.next = 'none';
									// } else {
									// 	t.next = 'block';
									// }
									// if (t.sliact == this.activeIndex && t.sliact == this.slides.length - 2) {
									// 	t.next = 'none';
									// } else {
									// 	t.sliact = this.activeIndex;
									// }
								},
							},
						});
					}
					
					t.innerSwipers.push(innerSwiper);
					// t.$nextTick(function(){
					// 	if(t.list.data.content[t.tabXz].child.length>2){
					// 		t.prev = 'block';
					// 		t.next = 'block';
					// 	}else{
					// 		t.prev = 'none';
					// 		t.next= 'none';
					// 	}
					// })
				});
			},
			tabXz(e,a){
				
				let left=0
				this.list.data.content.map((v,ca)=>{
					if(this.tabXz>ca){
						let elOne=document.getElementById('item'+ca)
						left+=parseInt(window.getComputedStyle(elOne).getPropertyValue("width"))+20;
					}
					
				})
				
				let el=document.getElementById('item'+this.tabXz);
				if(el){
					this.tabWidth=window.getComputedStyle(el).width
				}else{
					this.tabWidth= ''
				}
				if(this.tabXz==0){
					return this.tableftTwo=0
				}
				this.$nextTick(function(){
					this.tableftTwo=left
				})
			},
			
		},
		mounted() {
			let t = this;
			t.getWidth();
			let aa=setInterval(function(){
				let el=document.getElementById('item'+t.tabXz);
				if(el){
					t.tabWidth= window.getComputedStyle(el).width;
					clearInterval(aa)
				}
			},100)
		},
		methods: {
			getWidth(){
				console.log(document.body.clientWidth,window.screen.availWidth)
				let width=''
				if(document.body.clientWidth>1200){
					 width=document.body.clientWidth - 1200;
				}else{
					 width=0;
				}
				this.$nextTick(function(){
					this.bj=width/2
				})
			},
			goTab(e) {
				console.log(e)
				let t=this;
				this.tabXz = e;
				this.mySwiper.slideTo(e);
				this.sliact = 0;
				
				this.innerSwipers.forEach(function(swiper) {
					swiper.slideTo(0);
					swiper.update();
					
					swiper.allowTouchMove= t.list.data.content[t.tabXz].child.length > 1 ? true : false;
					if(t.list.data.content[t.tabXz].child.length>2){
						t.prev = 'none';
						t.next = 'block';
					}else{
						t.prev = 'none';
						t.next= 'none';
						return
					}
					
					swiper.on('slideChangeTransitionEnd',function() {
						if (this.activeIndex === 0) {
							t.prev = 'none';
						} else {
							t.prev = 'block';
						}
						if (this.activeIndex === this.slides.length - 1) {
							t.next= 'none';
						} else {
							t.next = 'block';
						}
						// if (this.activeIndex === this.slides.length - 2) {
						// 	t.next= 'none';
						// } else {
						// 	t.next = 'block';
						// }
						// if (t.sliact == this.activeIndex && t.sliact == this.slides.length - 2) {
						// 	t.next = 'none';
						// } else {
						// 	t.sliact = this.activeIndex;
						// }
					})
				});
				// this.mySwiper.slideNext()
				// this.mySwiper.slidePrev()
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.swiper-hexin {
		overflow: hidden;
	}

	.swiper-hexinTwo {
		overflow: hidden;
		position: relative;

		.swiper-hexin-prev {
			position: absolute;
			top: 220px;
			left: 260px;
			z-index: 99;
			width: 51px;
			height: 51px;

			img {
				width: 51px;
				height: 51px;
			}

			border-radius: 100%;
			transform: translateY(-50%);
			transition: all 0.3s ease;
			cursor: pointer;
		}

		.swiper-hexin-next {
			transform: translateY(-50%);
			position: absolute;
			top: 220px;
			right: 260px;
			z-index: 99;
			width: 51px;
			height: 51px;
			border-radius: 100%;
			transition: all 0.3s ease;
			cursor: pointer;
			img {
				width: 51px;
				height: 51px;
			}
		}
	}

	.swiper-slideTwo {
		position: relative;

		width: 580px !important;
		.swiper-slideTwo-img {
			width: 580px;
			height: 440px;
			margin-bottom: 34px;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		.swiper-slideTwo-name {
			font-size: 26px;
			
			font-weight: 400;
			color: #000000;
			margin-bottom: 32px;
			width: 580px;
		}

		.swiper-slideTwo-cen {
			font-size: 18px;
			
			font-weight: 300;
			color: #000000;
			width: 580px;
			>div{
				white-space: pre-line;
			}
		}
	}

	.data19 {
		margin-bottom: 150px;

		.data19TilBox {
			width: 1200px;
			margin: 0 auto;
		}

		.data19Til {
			font-size: 45px;
			
			font-weight: bold;
			color: #000000;
			margin-bottom: 92px;
		}

		.data19Tab {
			padding-bottom: 35px;
			display: flex;
			align-items: center;
			border-bottom: 2px solid #E5E5E5;
			margin-bottom: 56px;
			position: relative;
			// .data19TabFor:nth-of-type(1) {
			// 	width: 60%;
			// }

			// .data19TabFor:nth-of-type(2) {
			// 	width: 20%;
			// }

			// .data19TabFor:nth-of-type(3) {
			// 	width: 20%;
			// }
			.data19TabFor:not(:last-child) {
				padding-right: 20px;
			}
			.data19TabFor {
				font-size: 26px;
				
				font-weight: 300;
				color: #000000;
				cursor: pointer;
				display: flex;
				align-items: center;
				justify-content: center;
				position: relative;
			}

			.data19TabXian {
				position: absolute;
				bottom: -1px;
				left: 0;
				height: 2px;
				background: #000000;
				transition: all .3s ease-in-out;
			}
		}
	}
	@media screen and (max-width:1200px) {
		.data19 {
			padding: 0 30px !important;
			margin-bottom: 30px !important;
			box-sizing: border-box;
			.data19TilBox {
				width: 100% !important;
			}
			.data19Til {
				font-size: 24px !important;
				margin-bottom: 20px !important;
			}
			.data19Tab {
				padding-bottom: 20px !important;
				margin-bottom: 20px !important;
				.data19TabFor{
					font-size: 14px !important;
				}
			}
			.swiper-slide{
				width:100% !important;
			}
			.swiper-slideTwo{
				max-width: 100% !important;
				margin-right: 20px !important;
				.swiper-slideTwo-img{
					max-width: 100% !important;
					height: auto !important;
					margin-bottom: 20px !important;
					img{
						object-fit: contain !important;
					}
				}
				.swiper-slideTwo-name{
					max-width: 100% !important;
					font-size: 18px !important;
					margin-bottom: 10px !important;
				}
				.swiper-slideTwo-cen{
					max-width: 100% !important;
					font-size: 14px !important;
				}
				
			}
			
		}
	}
</style>